import {WixSdk} from '@wix/js-sdk-wrapper';
import {parseParams} from '@wix/music-shared/dist/src/utils/url';

export function withMock() {
  if ((process.env.NODE_ENV === 'development' && window.top === window) || parseParams().viewMode === 'standalone') {
    mockEnvironment();
  }
}

export function mockEnvironment() {
  const {svSession, pageId, compId, siteUrl = 'https://local.wix.com', externalId} = parseParams();

  WixSdk.Activities.getUserSessionToken = () => Promise.resolve(svSession || 'LOCAL_S_TOKEN');

  WixSdk.Data.Public.get = () => Promise.reject();

  WixSdk.getExternalId = () => Promise.resolve(externalId);

  WixSdk.getSiteInfo = () => {
    return Promise.resolve({
      pageTitleOnly: 'Page Title',
      siteDescription: '',
      siteKeywords: '',
      referer: '',
      pageTitle: 'Page Title | Home',
      url: siteUrl,
      baseUrl: siteUrl,
    });
  };

  WixSdk.getComponentInfo = () =>
    Promise.resolve({
      appPageId: '',
      compId,
      pageId,
      showOnAllPages: false,
      tpaWidgetId: 'wix_music',
    });

  WixSdk.getSitePages = () =>
    Promise.resolve([
      {
        hide: false,
        id: pageId,
        isHomepage: true,
        title: 'HOME',
      },
    ]);

  WixSdk.getCurrentPageId = () => Promise.resolve(pageId);

  WixSdk.getBoundingRectAndOffsets = () =>
    Promise.resolve({
      offsets: {
        x: 19.5,
        y: 337,
      },
      rect: {
        left: 19,
        right: 500,
        top: 73,
        bottom: 793,
        height: window.innerHeight,
        width: window.innerWidth,
      },
      scale: 1,
    });
}
